import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="text-center py-24 text-neutral-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/kayit" state={{ next: loc.pathname }} replace />;
  return children;
}
